import React, { useState, useEffect, useCallback } from "react";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { Button, Modal, Form, Alert } from "react-bootstrap";
import Select from "react-select";
import ImageUpload from "../ImageUpload";
import ImageCropper from "./ImageCropper"; // Import du cropper
import { getImageFullUrl } from '../../services/ApiService'; // Utile pour la prévisualisation

const TARGET_MEDIA_WIDTH = 150;
const TARGET_MEDIA_HEIGHT = 75;

export default function OperationsTypeModal({
  handleClose,
  show,
  handleAddOperations,
  handleOperationsChange,
  operationsType,
  handleOffersDescriptionChange,
  handleDeleteOfferDescription,
  handleAddOfferDescription,
  action,
  brandList,
  valueBrand,
  setBrand,
  operationsDescriptions,
  errorMessage,
}) {
  const [indexDelete, setIndexDelete] = React.useState();
  const [formData] = React.useState({
    name: operationsType.name || "",
    colorInput: operationsType.color || "",
    brand: valueBrand || "",
    media: operationsType.media || null, // Chemin string ou objet File
    operationsDescriptions:
      operationsDescriptions || operationsType.operation_descriptions || "",
  });
  const [newFormData, setNewFormData] = React.useState({
    ...formData,
  });

  // --- NOUVEL ÉTAT POUR LE RECADRAGE ---
  const [imageToCrop, setImageToCrop] = useState(null); // Contient { fieldName, imageSrc }

  // --- NOUVELLE FONCTION UTILITAIRE POUR L'APERÇU ---
  // Pour gérer l'affichage des images déjà existantes ou des images fraîchement recadrées
  const getMediaPreviewUrl = (mediaValue) => {
    if (mediaValue instanceof File) {
        return URL.createObjectURL(mediaValue);
    }
    if (typeof mediaValue === 'string' && mediaValue) {
        return getImageFullUrl(mediaValue);
    }
    return null;
  };
  // -------------------------------------------------

  // Synchronisation initiale ou sur changement d'operationsType
  useEffect(() => {
    setNewFormData({
      name: operationsType.name || "",
      colorInput: operationsType.color || "",
      brand: valueBrand || "",
      media: operationsType.media || null, // Média initial (chemin string)
      operationsDescriptions:
        operationsDescriptions || operationsType.operation_descriptions || [],
    });
  }, [operationsType, brandList, valueBrand, operationsDescriptions]);


  const handleInputChange = (e, indexOrName = "") => {
    if (indexOrName === "brand") {
      setNewFormData({
        ...newFormData,
        brand: e,
      });
    } else if (indexOrName === "media") {
      // Si un objet File est passé, cela signifie qu'un fichier a été sélectionné
      if (e instanceof File) {
        const reader = new FileReader();
        reader.onload = (event) => {
          setImageToCrop({ 
            fieldName: "media", // Le champ que nous mettons à jour
            imageSrc: event.target.result // L'image Base64 pour le cropper
          });
        };
        reader.readAsDataURL(e);
      } else if (e === null) {
        // Cas de suppression de l'image
        setNewFormData((prevData) => ({
          ...prevData,
          media: null,
        }));
        handleOperationsChange(null, "media"); // Signaler la suppression au parent
      } else {
        // Si c'est un chemin string ou autre, on met à jour directement (moins probable avec cropper)
        setNewFormData({
            ...newFormData,
            media: e,
        });
        handleOperationsChange(e, "media");
      }
    } else if (e.target.name === "operationsDescriptions") {
      setNewFormData((prevData) => {
        return {
          ...prevData,
          operationsDescriptions: prevData.operationsDescriptions[indexOrName]
            ? prevData.operationsDescriptions.map((elt, i) =>
              i === indexOrName ? { ...elt, name: e.target.value } : elt
            )
            : [
              ...prevData.operationsDescriptions,
              {
                name: "",
                operation_type_id: "",
              },
            ],
        };
      });
    } else {
      setNewFormData({
        ...newFormData,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleModalHide = () => {
    var windowConfirm = false;
    // Comparaison des deux objets (formData est l'état initial)
    // Exclure 'media' de la comparaison directe car il peut être File ou string
    const newFormDataForComparison = { ...newFormData, media: null };
    const formDataForComparison = { ...formData, media: null };

    if (JSON.stringify(formDataForComparison) !== JSON.stringify(newFormDataForComparison)) {
      windowConfirm = true;
    }
    // Gérer spécifiquement le cas du média (si File ou string différent)
    if (newFormData.media instanceof File || (newFormData.media !== formData.media && newFormData.media !== null && formData.media !== null)) {
        windowConfirm = true;
    }


    if (windowConfirm) {
      if (
        window.confirm(
          "Vous avez effectué des changements, êtes vous sûr de vouloir quitter sans valider ?"
        )
      ) {
        handleClose();
      }
    } else {
      handleClose();
    }
  };
  const handleDeleteInModal = (i) => {
    if (
      operationsType.operation_descriptions &&
      !(
        JSON.stringify(operationsType.operation_descriptions[i]) ===
        JSON.stringify(newFormData.operationsDescriptions[i])
      )
    ) {
      setNewFormData((prevState) => ({
        ...prevState,
        operationsDescriptions: prevState.operationsDescriptions.filter(
          (item, index) => index !== i
        ),
      }));
    }

    if (
      operationsDescriptions &&
      !(
        JSON.stringify(operationsDescriptions[i]) ===
        JSON.stringify(newFormData.operationsDescriptions[i])
      )
    ) {
      setNewFormData((prevState) => ({
        ...prevState,
        operationsDescriptions: prevState.operationsDescriptions.filter(
          (item, index) => index !== i
        ),
      }));
    }
  };

  React.useEffect(() => {
    if (
      operationsDescriptions &&
      operationsDescriptions.length < newFormData.operationsDescriptions.length
    ) {
      handleDeleteInModal(indexDelete);
    }
    if (
      operationsType.operation_descriptions &&
      operationsType.operation_descriptions.length <
      newFormData.operationsDescriptions.length
    ) {
      handleDeleteInModal(indexDelete);
    }
  }, [operationsType.operation_descriptions, operationsDescriptions, newFormData.operationsDescriptions.length, indexDelete]); // Ajout de dépendances pour éviter les avertissements


  /**
   * 2. Gère le fichier final après recadrage.
   * @param {File} croppedFile - Le fichier image final (Blob converti en File).
   */
  const handleCropComplete = useCallback((croppedFile) => {
    // Met à jour l'état du formulaire avec le nouveau Fichier binaire
    setNewFormData((prevData) => ({
      ...prevData,
      media: croppedFile,
    }));
    // Signaler au parent le fichier recadré pour mise à jour immédiate si nécessaire
    handleOperationsChange(croppedFile, "media");
    
    // Ferme le cropper
    setImageToCrop(null);
  }, [handleOperationsChange]);
  
  /**
   * Annulation du recadrage
   */
  const handleCropCancel = () => {
    setImageToCrop(null);
  };


  // AFFICHER LE CROPPER SI UNE IMAGE EST EN ATTENTE
  if (imageToCrop) {
      return (
          <Modal show={show} size="xl" onHide={handleCropCancel} centered>
              <Modal.Header closeButton>
                  <Modal.Title>Recadrer l'image pour le Média d'Opération</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                  <div style={{ height: '500px' }}>
                      <ImageCropper 
                          imageSrc={imageToCrop.imageSrc}
                          targetWidth={TARGET_MEDIA_WIDTH} // 150px
                          targetHeight={TARGET_MEDIA_HEIGHT} // 75px
                          onComplete={handleCropComplete}
                          onCancel={handleCropCancel}
                      />
                  </div>
              </Modal.Body>
          </Modal>
      );
  }


  return (
    <>
      <Modal
        show={show}
        size="lg"
        onHide={() => handleModalHide()}
        centered
        className="w-100"
      >
        <Modal.Header closeButton>
          <Modal.Title>{action}</Modal.Title>
        </Modal.Header>
        <Form onSubmit={(e) => handleAddOperations(e, newFormData)}>
          <Modal.Body>
            <div className="row">
              <div className="col mb-3">
                <Form.Group className="mb-3" controlId="new-operation">
                  <Form.Label>Nom Opération</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Nom"
                    className="mb-3"
                    autoFocus
                    required
                    maxLength="25"
                    value={operationsType.name}
                    name="name"
                    onChange={(e) => {
                      handleInputChange(e);
                      handleOperationsChange(e, "name");
                    }}
                  />
                </Form.Group>
                {errorMessage ? (
                  <div className="col-md-12 my-3 p-1 text-center">
                    <Alert variant="danger" className="m-0">
                      {errorMessage}
                    </Alert>
                  </div>
                ) : (
                  ""
                )}
                <Select
                  placeholder="Choisir une marque"
                  required
                  isDisabled={
                    action.includes("Modifier Opération") ? true : false
                  }
                  value={valueBrand}
                  name="brand"
                  onChange={(e) => {
                    handleInputChange(e, "brand");
                    setBrand(e);
                  }}
                  options={brandList}
                  className="black border-white"
                />
                <Form.Group className="my-3" controlId="new-color">
                  <Form.Label>Couleur opération</Form.Label>
                  <div className="row pt-2 ">
                    <div className="col-md-2">
                      <span>
                        <LocalOfferOutlinedIcon
                          style={{ color: operationsType.color }}
                        />{" "}
                        &emsp;
                      </span>
                    </div>
                    <div className="col-md-4 pr-0">
                      <Form.Control
                        type="text"
                        placeholder="#a82424"
                        autoFocus
                        required
                        pattern="^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$"
                        title="Le code hexadécimal doit être de 6 caractères et avec # devant, ex : #a82424"
                        value={operationsType.color}
                        name="colorInput"
                        onChange={(e) => {
                          handleInputChange(e);
                          handleOperationsChange(e, "color");
                        }}
                      />
                    </div>
                    <div className="col-md-3">
                      <Form.Group
                        controlId="color"
                        className="row align-items-center"
                      >
                        <Form.Label className="col-md">
                          <SearchOutlinedIcon />
                        </Form.Label>
                        <Form.Control
                          type="color"
                          required
                          className="col-md"
                          value={operationsType.color}
                          name="colorInput"
                          onChange={(e) => {
                            handleInputChange(e);
                            handleOperationsChange(e, "color");
                          }}
                        />
                      </Form.Group>
                    </div>
                  </div>
                </Form.Group>
                <ImageUpload
                  value={getMediaPreviewUrl(newFormData.media)} // Utilise la nouvelle fonction d'aperçu
                  onChange={(fileOrNull) => { 
                    handleInputChange(fileOrNull, "media");
                    // handleOperationsChange n'est plus appelé directement ici,
                    // il le sera après le recadrage via handleCropComplete
                  }}
                  label="Média "
                  maxSizeMB={5}
                  // Dimensions maximales sont maintenant gérées par le cropper
                  // maxImageWidth={150} 
                  // maxImageHeight={75}
                />
                <div className="grey pt-3">Formats autorisés: jpg, png</div>
                <div className="grey">Largeur max: 150px (~4cm)<br />Hauteur max: 75px (~2cm)</div>
                <div className="grey">Proportion largeur/hauteur: 2/1</div>
                <div className="grey pb-3">Résolution conseillée: 300px/pouces</div>

              </div>
              <div className="col-md border-start">
                <Form.Group className="mb-3" controlId="new-offer">
                  <Form.Label>Descriptifs offre</Form.Label>
                  {newFormData.operationsDescriptions && // Utiliser newFormData pour le rendu
                    newFormData.operationsDescriptions.map((opedescription, i) => (
                      <div className="row px-2 " key={i}>
                        <Form.Control
                          type="text"
                          placeholder="descriptif offre..."
                          autoFocus
                          required
                          value={opedescription.name}
                          maxLength="65"
                          name="operationsDescriptions"
                          onChange={(e) => {
                            handleInputChange(e, i);
                            handleOffersDescriptionChange(e, i);
                          }}
                          className="col-md mb-2"
                        />
                        <span className="col-1" key={i}>
                          <DeleteOutlineIcon
                            className="delete-icon-operation red cursor-pointer"
                            onClick={() => {
                              handleDeleteOfferDescription(i); // Supprime l'entrée directement
                              setIndexDelete(i);
                            }}
                          />
                        </span>
                      </div>
                    ))}
                  <div>
                    <AddCircleOutlineOutlinedIcon
                      onClick={() => {
                        handleAddOfferDescription();
                        setNewFormData((prevData) => {
                          return {
                            ...prevData,
                            operationsDescriptions: [
                              ...prevData.operationsDescriptions,
                              {
                                name: "",
                                operation_type_id: "",
                              },
                            ],
                          };
                        });
                      }}
                      className="add-icon-operation blue cursor-pointer"
                    />
                  </div>
                </Form.Group>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="is-bottom-right">
            <Button variant="secondary" onClick={handleClose}>
              Annuler
            </Button>
            <Button variant="success" type="submit">
              valider
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}